import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';

export const MobileWrapper = styled.div<{ $extraMargin?: boolean }>`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: block;
    margin-top: ${({ $extraMargin }) => ($extraMargin ? spacing.space40 : 0)};
  }
`;

export const DiscountWrapper = styled.div`
  margin-bottom: ${spacing.space32};
`;

export const BenefitDiscountCopyWrapper = styled.div`
  display: flex;
  margin-bottom: ${spacing.space32};
`;

export const Body = styled.div`
  margin-bottom: ${spacing.space40};

  & > div:first-child {
    max-width: 100%;

    & > :not(h3):first-child {
      margin-top: 0;
    }

    & > :last-child {
      margin-bottom: 0;
    }
  }

  blockquote {
    max-width: 576px;
  }

  h3 {
    &:has(+ .accordion) {
      margin-bottom: -4px;
    }
  }

  p {
    margin: 25px 0;
    max-width: 576px;

    a:hover {
      color: ${colors.secondary[500]};
    }
  }

  p + h2,
  ul + h2,
  ol + h2,
  table + h2 {
    margin-top: 54px;
  }

  h2 + p,
  h2 + ul,
  h2 + table,
  h2 + ol {
    margin-top: 29px;
  }
`;
